import Link from "next/link"
import React from "react"

interface BasicLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isNewTab?: boolean
  isExternal?: boolean
  children: any
}

export const BasicLink: React.FC<BasicLinkProps> = ({
  children,
  href = "",
  isNewTab = false,
  isExternal = false,
  className,
  ...rest
}: BasicLinkProps) => {
  if (isExternal || isNewTab) {
    return (
      <a
        target={isNewTab ? "_blank" : "_self"}
        rel="noopener noreferrer"
        href={href}
        {...rest}
        className={className}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={href} {...rest} className={className}>
      {children}
    </Link>
  )
}
